// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.about.AboutInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AboutInfoItem } from "abweb/dto/generated/about/AboutInfoItem";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class AboutInfo {
  static createAboutInfo(items) {
    const retVal = new AboutInfo();
    retVal.initAboutInfo(items);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createAboutInfo factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawada.AboutInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initAboutInfo(json.items != null ? TSOGUtils.decodeObjectArray(json.items, AboutInfoItem, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "items")) : null);
  }
  initAboutInfo(items) {
    this._items = items;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._items != null) {
      retVal["items"] = TSOGUtils.toTSOGArray(this._items, serializeContext);
    }
    return retVal;
  }
  get items() {
    return this._items;
  }
  set items(value) {
    this._items = value;
  }
}
//# sourceMappingURL=AboutInfo.js.map
